import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeStyle as _normalizeStyle, Teleport as _Teleport } from "vue"

const _hoisted_1 = {
  class: "tw-w-full",
  ref: "root"
}
const _hoisted_2 = { class: "tw-relative tw-w-full tw-min-w-0" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = { class: "tw-flex tw-items-center tw-gap-2 tw-flex-shrink-0" }
const _hoisted_5 = {
  ref: "afterChangeFocusEl",
  tabindex: "-1",
  class: "tw-outline-none"
}
const _hoisted_6 = {
  key: 0,
  class: "tw-p-2 tw-border-b tw-border-slate-200/70"
}
const _hoisted_7 = { class: "tw-relative" }
const _hoisted_8 = ["placeholder"]
const _hoisted_9 = { class: "tw-max-h-64 tw-overflow-auto tw-p-1" }
const _hoisted_10 = ["onMouseenter", "onClick"]
const _hoisted_11 = { class: "tw-truncate" }
const _hoisted_12 = {
  key: 0,
  class: "tw-px-3 tw-py-2 tw-text-sm tw-text-slate-500"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.textLabel)
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          class: _normalizeClass(["tw-block tw-mb-1 tw-text-xs tw-font-medium tw-uppercase tw-tracking-wide tw-text-slate-500", _ctx.size === 'sm' ? 'tw-h-4 tw-leading-4' : ''])
        }, _toDisplayString(_ctx.textLabel), 3))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        ref: "buttonEl",
        type: "button",
        class: _normalizeClass(["tw-w-full tw-flex tw-items-center tw-gap-2 tw-border tw-border-slate-300 tw-text-left tw-shadow-sm tw-shadow-slate-900/5 tw-transition focus:tw-outline-none focus:tw-ring-4 focus:tw-ring-indigo-500/15 focus:tw-border-indigo-500/55", [
          _ctx.size === 'sm' ? 'tw-rounded-lg tw-px-2 tw-py-1.5 tw-text-sm' : 'tw-rounded-xl tw-px-3 tw-py-2',
          _ctx.disabled
            ? 'tw-bg-slate-50 tw-border-slate-200 tw-text-slate-400 tw-cursor-not-allowed'
            : 'tw-bg-white/70 tw-border-slate-300/70 tw-text-slate-900 hover:tw-bg-white',
          _ctx.isOpen && !_ctx.disabled ? 'tw-ring-4 tw-ring-indigo-500/15 tw-border-indigo-500/55' : '',
        ]]),
        disabled: _ctx.disabled,
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggle && _ctx.toggle(...args)))
      }, [
        _createElementVNode("span", {
          class: _normalizeClass(["tw-flex-1 tw-min-w-0 tw-truncate", _ctx.selectedLabel ? 'tw-text-slate-900' : 'tw-text-slate-500'])
        }, _toDisplayString(_ctx.selectedLabel || _ctx.placeholder || 'Select…'), 3),
        _createElementVNode("span", _hoisted_4, [
          (_ctx.clearable && !_ctx.disabled && _ctx.modelValue != null && _ctx.modelValue !== '')
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "tw-inline-flex tw-items-center tw-justify-center tw-rounded-lg tw-text-slate-500 hover:tw-text-slate-700",
                "aria-label": "Clear",
                onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.clear && _ctx.clear(...args)), ["stop"]))
              }, [
                _createVNode(_component_font_awesome_icon, {
                  icon: "xmark",
                  class: "tw-h-4 tw-w-4"
                })
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_font_awesome_icon, {
            icon: "chevron-down",
            class: _normalizeClass(["tw-h-4 tw-w-4 tw-text-slate-500 tw-transition-transform", _ctx.isOpen ? 'tw-rotate-180' : ''])
          }, null, 8, ["class"])
        ])
      ], 10, _hoisted_3),
      _createElementVNode("span", _hoisted_5, null, 512),
      (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
        (_ctx.isOpen && !_ctx.disabled)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              ref: "menuEl",
              class: "tw-fixed tw-z-[3000] tw-overflow-hidden tw-rounded-xl tw-border tw-border-slate-300/70 tw-bg-white tw-shadow-xl tw-shadow-slate-900/50",
              style: _normalizeStyle(_ctx.menuStyle)
            }, [
              (_ctx.searchable)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _withDirectives(_createElementVNode("input", {
                        ref: "searchInput",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.query) = $event)),
                        type: "text",
                        class: "tw-w-full tw-rounded-lg tw-border tw-border-slate-300 tw-bg-white tw-px-3 tw-py-2 tw-text-sm tw-text-slate-900 placeholder:tw-text-slate-400 focus:tw-outline-none focus:tw-ring-4 focus:tw-ring-indigo-500/25 focus:tw-border-indigo-500/65",
                        placeholder: _ctx.selectedLabel || _ctx.placeholder || 'Select…',
                        onKeydown: [
                          _cache[3] || (_cache[3] = _withKeys(_withModifiers(($event: any) => (_ctx.moveActive(1)), ["prevent"]), ["down"])),
                          _cache[4] || (_cache[4] = _withKeys(_withModifiers(($event: any) => (_ctx.moveActive(-1)), ["prevent"]), ["up"])),
                          _cache[5] || (_cache[5] = _withKeys(_withModifiers(($event: any) => (_ctx.selectActive()), ["prevent"]), ["enter"])),
                          _cache[6] || (_cache[6] = _withKeys(_withModifiers(($event: any) => (_ctx.close()), ["prevent"]), ["esc"]))
                        ]
                      }, null, 40, _hoisted_8), [
                        [_vModelText, _ctx.query]
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_9, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredOptions, (opt, idx) => {
                  return (_openBlock(), _createElementBlock("button", {
                    key: _ctx.optionKey(opt, idx),
                    type: "button",
                    class: _normalizeClass(["tw-w-full tw-flex tw-items-center tw-justify-between tw-gap-3 tw-rounded-lg tw-px-3 tw-py-2 tw-text-left tw-text-sm tw-transition", [
                idx === _ctx.activeIndex ? 'tw-text-slate-900 tw-bg-slate-900/20 ' : 'tw-text-slate-700 hover:tw-bg-slate-900/30',
              ]]),
                    onMouseenter: ($event: any) => (_ctx.activeIndex = idx),
                    onClick: ($event: any) => (_ctx.selectOption(opt))
                  }, [
                    _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.optionLabel(opt)), 1),
                    (_ctx.isSelected(opt))
                      ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                          key: 0,
                          icon: "check",
                          class: "tw-h-4 tw-w-4 tw-text-slate-700 tw-flex-shrink-0"
                        }))
                      : _createCommentVNode("", true)
                  ], 42, _hoisted_10))
                }), 128)),
                (_ctx.filteredOptions.length === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, " No results "))
                  : _createCommentVNode("", true)
              ])
            ], 4))
          : _createCommentVNode("", true)
      ]))
    ])
  ], 512))
}